module.exports = __webpack_public_path__ + "img/poza_mea.35cb5022.jpeg";